export enum WorkflowFieldTypes {
  Dropdown = 'Dropdown',
  CheckboxList = 'CheckboxList',
  RadioButtonList = 'RadioButtonList'
}
